import { observer } from "mobx-react";
import * as React from "react";
import { MDBDropdown, MDBDropdownItem, MDBDropdownMenu, MDBDropdownToggle } from "mdbreact";
import { CentralStore } from "../../stores/erros/CentralStore";
import { AppStore } from "../../stores/AppStore";
import history from "../others/redirect";
import { CALCULO_ITENS, CLASSIFICACAO, CNPJS_ITEMS, IMPORTCOES_MANIFESTACOES_SEFIP, INavItem, MANIFESTACOES, NAV_ITEMS, NAV_ITEMS4, NAV_ITEMS4_SUB, NAV_LEGISLACAO_ARQUIVOS_PA, NAV_LEGISLACAO_RS, NAV_LEGISLACAO_TABELAS_PA, NAV_RELATORIO, NAV_RELATORIO_CADASTROS, NAV_RELATORIO_EMPRESAS, SEFIP, XMLS_ITEMS, XMLS_ITEMS_SUB } from "./NavItens";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { LegislacaoStore } from "../../stores/legislacao/LegislacaoStore";

require("../../assets/css/components/NavMenu.css");

@observer
export default class NavMenu extends React.Component<{}, {}> {

  async componentDidMount() {

    await CentralStore.load();

  }

  closeDrowpDown() {
    document.getElementById("DrowpDownClose").style.visibility = "collapse";
  }

  openDrowpDown() {
    document.getElementById("DrowpDownClose").style.visibility = "";
  }

  closeDrowpDownDecla() {
    document.getElementById("DrowpDownCloseDecla").style.visibility = "collapse";
  }

  openDrowpDownDecla() {
    document.getElementById("DrowpDownCloseDecla").style.visibility = "";
  }

  closeDrowpDownLegis() {
    document.getElementById("DrowpDownCloseLegis").style.visibility = "collapse";
  }

  openDrowpDownLegis() {
    document.getElementById("DrowpDownCloseLegis").style.visibility = "";
  }

  openDrowpDownRelatorio() {
    document.getElementById("DropDownCloseRelatorio").style.visibility = ""
  }

  closeDrowpDownRelatorio() {
    document.getElementById("DropDownCloseRelatorio").style.visibility = "collapse"
  }

  async onPush(path) {

    EmpresaStore.obs.certificado = "";
    EmpresaStore.obs.status = "";

    if (path == "/calculo-icms") {

      await LegislacaoStore.get_pdf("icms")
      return

    }

    if (path == "/decreto-icms") {

      await LegislacaoStore.get_pdf("decreto")
      return

    }

    history.push(path)

  }

  renderItem = (item: INavItem, admin: boolean) => {
    let className = "nz-nav-menu-item";
    let classNameSpan = "badge-emp pulse hidden-span";

    if (AppStore.obs1.location.area == item.area) {
      className += " mod-selected";
    }
    if (admin) className += " mod-admin";

    let path = `/${item.area}`;
    if (item.action) path += `/${item.action}`;

    return (
      <li key={item.key} className="nav-item" onClick={() => this.onPush(path)}>
        <a className={className}>
          <span className="icon-nav-menu">
            {AppStore.obs1.location.area == item.area
              ? item.iconActive
              : item.icon}
          </span>
          {item.key == "dei" || item.key == "faixa-simples" || item.key == "relatorio_parcelamento" || item.key == "integracoes" ?
            <div className="nz-nav-menu-item-text">{item.text} <span className="new-tag-nav-new">Novo</span></div>
            :
            <>
              {item.key == "parcelamentos" ?
                <div className="nz-nav-menu-item-text">{item.text} <span className="new-tag-nav-new">Beta</span></div>
                :
                <div className="nz-nav-menu-item-text">{item.text}</div>
              }
            </>
          }
          <span className={classNameSpan}></span>
        </a>
      </li>
    );
  };

  renderDashboard() {

    return NAV_ITEMS?.map(item => this.renderItem(item, false));

  }

  renderEmpresas() {

    return CNPJS_ITEMS?.map(item => this.renderItem(item, false));
  }

  renderDeclaracoes() {

    return (<>

      <li className="itensAdmin">
        <MDBDropdown className="dropdownAdmin dropdownMenu">
          <MDBDropdownToggle onClick={() => this.openDrowpDownDecla()} caret color="default">
            <img src="/images/money.png" width="27px;" /> Declarações
          </MDBDropdownToggle>
          <div id="DrowpDownCloseDecla">
            <MDBDropdownMenu basic>

              <MDBDropdownItem>
                {NAV_ITEMS4?.map(item => this.renderItem(item, true))}
              </MDBDropdownItem>

            </MDBDropdownMenu>
          </div>
        </MDBDropdown>
      </li>

    </>)

  }

  renderXmlsRS() {

    return (<>

      <li className="itensAdmin">
        <MDBDropdown className="dropdownAdmin dropdownMenu">
          <MDBDropdownToggle onClick={() => this.openDrowpDown()} caret color="default">
            <img src="/images/xml.svg" width="27px;" /> XMLs
          </MDBDropdownToggle >
          <div id="DrowpDownClose">
            <MDBDropdownMenu basic>
              <MDBDropdownItem>
                {XMLS_ITEMS?.map(item => this.renderItem(item, true))}
              </MDBDropdownItem>
            </MDBDropdownMenu>
          </div>
        </MDBDropdown>
      </li>

    </>)

  }

  renderXmlsPA() {

    return (<>

      <li className="itensAdmin">
        <MDBDropdown className="dropdownAdmin dropdownMenu">
          <MDBDropdownToggle onClick={() => this.openDrowpDown()} caret color="default">
            <img src="/images/xml.svg" width="27px;" /> XMLs
          </MDBDropdownToggle >
          <div id="DrowpDownClose">
            <MDBDropdownMenu basic>
              <MDBDropdownItem>
                {XMLS_ITEMS?.map(item => this.renderItem(item, true))}
              </MDBDropdownItem>
              <MDBDropdown dropright className="dropdownAdmin dropdownMenu dropdownMenuXml">
                <MDBDropdownToggle className="buttonSubmenu" caret color="default">
                  {"Solicitações de Arquivos"}&nbsp;&nbsp;
                </MDBDropdownToggle>
                <MDBDropdownMenu basic>
                  <p className="arquivos-divider">Pará: </p>
                  <div className="dropdown-divider" />
                  <MDBDropdownItem onClick={() => this.closeDrowpDown()}>
                    {XMLS_ITEMS_SUB?.map(item => this.renderItem(item, true))}
                  </MDBDropdownItem>
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBDropdownMenu>
          </div>
        </MDBDropdown>
      </li>

    </>)

  }

  renderCalculos() {

    return (<>

      <li className="itensAdmin">
        <MDBDropdown className="dropdownAdmin dropdownMenu">
          <MDBDropdownToggle caret color="default">
            <img src="/images/calculos.svg" width="27px;" />{" "}
            Cálculos
          </MDBDropdownToggle>
          <MDBDropdownMenu basic>
            <MDBDropdownItem>
              {CALCULO_ITENS?.map(item => this.renderItem(item, true))}
            </MDBDropdownItem>
          </MDBDropdownMenu>
        </MDBDropdown>
      </li>

    </>)

  }

  renderLegislacaoPA() {

    return (<>

      <li className="itensAdmin">
        <MDBDropdown className="dropdownAdmin dropdownMenu">
          <MDBDropdownToggle onClick={() => this.openDrowpDownLegis()} caret color="default">
            <img src="/images/legislacao.png" width="27px;" /> Legislação
          </MDBDropdownToggle >
          <div id="DrowpDownCloseLegis">
            <MDBDropdownMenu basic>
              <p className="arquivos-divider">Pará </p>
              <div className="dropdown-divider" />

              <MDBDropdown dropright className="dropdownAdmin dropdownMenu dropdownMenuLegislacaoSub1">
                <MDBDropdownToggle className="buttonSubmenu" caret color="default">
                  {"Arquivos"}&nbsp;&nbsp;
                </MDBDropdownToggle>
                <MDBDropdownMenu basic>
                  <MDBDropdownItem onClick={() => this.closeDrowpDownLegis()}>
                    {NAV_LEGISLACAO_ARQUIVOS_PA?.map(item => this.renderItem(item, true))}
                  </MDBDropdownItem>
                </MDBDropdownMenu>
              </MDBDropdown>

              <MDBDropdown dropright className="dropdownAdmin dropdownMenu dropdownMenuLegislacaoSub2">
                <MDBDropdownToggle className="buttonSubmenu" caret color="default">
                  {"Tabelas"}&nbsp;&nbsp;
                </MDBDropdownToggle>
                <MDBDropdownMenu basic>
                  <MDBDropdownItem onClick={() => this.closeDrowpDownLegis()}>
                    {NAV_LEGISLACAO_TABELAS_PA?.map(item => this.renderItem(item, true))}
                  </MDBDropdownItem>
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBDropdownMenu>
          </div>
        </MDBDropdown>
      </li>

    </>)

  }

  renderLegislacaoRS() {

    return (<>

      <li className="itensAdmin">
        <MDBDropdown className="dropdownAdmin dropdownMenu">
          <MDBDropdownToggle onClick={() => this.openDrowpDownLegis()} caret color="default">
            <img src="/images/legislacao.png" width="27px;" /> Legislação
          </MDBDropdownToggle >
          <div id="DrowpDownCloseLegis">
            <MDBDropdownMenu basic>
              <p className="arquivos-divider">Rio Grande do Sul </p>
              <div className="dropdown-divider" />

              <MDBDropdown dropright className="dropdownAdmin dropdownMenu dropdownMenuLegislacaoSub2">
                <MDBDropdownToggle className="buttonSubmenu" caret color="default">
                  {"Tabelas"}&nbsp;&nbsp;
                </MDBDropdownToggle>
                <MDBDropdownMenu basic>
                  <MDBDropdownItem onClick={() => this.closeDrowpDownLegis()}>
                    {NAV_LEGISLACAO_RS?.map(item => this.renderItem(item, true))}
                  </MDBDropdownItem>
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBDropdownMenu>
          </div>
        </MDBDropdown>
      </li>

    </>)

  }

  renderRelatorios() {
    return (
      <li className="itensAdmin">
        <MDBDropdown className="dropdownAdmin dropdownMenu">
          <MDBDropdownToggle onClick={() => this.openDrowpDownRelatorio()} caret color="default">
            <img src="/images/relatorio.png" width="27px" /> Relatórios
          </MDBDropdownToggle>
          <div id="DropDownCloseRelatorio">
            <MDBDropdownMenu basic>
              <MDBDropdown dropright className="dropdownAdmin dropdownMenu dropdownMenuRelatorios">
                <MDBDropdownToggle className="buttonSubmenu" caret color="default">
                  Cadastros&nbsp;&nbsp;
                </MDBDropdownToggle>
                <MDBDropdownMenu basic>
                  <MDBDropdownItem onClick={() => this.closeDrowpDownRelatorio()}>
                    {NAV_RELATORIO_CADASTROS.map(item => this.renderItem(item, true))}
                  </MDBDropdownItem>
                </MDBDropdownMenu>
              </MDBDropdown>
              <MDBDropdownItem onClick={() => this.closeDrowpDownRelatorio()}>
                {NAV_RELATORIO.map(item => this.renderItem(item, true))}
              </MDBDropdownItem>
              <MDBDropdown dropright className="dropdownAdmin dropdownMenu dropdownMenuRelatorios">
                <MDBDropdownToggle className="buttonSubmenu" caret color="default">
                  Empresas&nbsp;&nbsp;
                </MDBDropdownToggle>
                <MDBDropdownMenu basic>
                  <MDBDropdownItem onClick={() => this.closeDrowpDownRelatorio()}>
                    {NAV_RELATORIO_EMPRESAS.map(item => this.renderItem(item, true))}
                  </MDBDropdownItem>
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBDropdownMenu>
          </div>
        </MDBDropdown>
      </li>
    );
  }

  render() {

    let userPermissao = AppStore.obs1.usuario ? AppStore.obs1.usuario.permissao : null;

    return (

      <div className="ul-menu">
        {!userPermissao ? (
          <>
            {this.renderDashboard()}
            {this.renderEmpresas()}
            {this.renderDeclaracoes()}
            {AppStore.obs1.usuario.conta.uf === "PA" || AppStore.obs1.usuario.conta.estado === "PA"
              ? this.renderXmlsPA()
              : this.renderXmlsRS()
            }
            {this.renderCalculos()}
            {AppStore.obs1.usuario.conta.uf === "PA" || AppStore.obs1.usuario.conta.estado === "PA"
              ? this.renderLegislacaoPA()
              : this.renderLegislacaoRS()}
            {this.renderRelatorios()}
          </>
        ) : (
          this.renderDashboard()
        )}
      </div>

    );

  }

}
